import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { authApi } from '../api/auth';
import { Btn } from '../components/Btn';
import { Input } from '../components/Field';
import { Logo } from '../components/Logo';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');

  const request = useMutation({
    mutationFn: () => authApi.requestPasswordReset(email),
  });

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    request.mutate();
  };

  return (
    <div
      className="auth-shell"
      style={{
        minHeight: '100vh',
        background: '#fbfaf6',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        color: '#0f1e3d',
        overflow: 'hidden',
      }}
    >
      <div
        className="desktop-only"
        style={{
          background: '#0f1e3d',
          color: '#fff',
          padding: '48px 56px',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          overflow: 'hidden',
        }}
      >
        <div style={{ zIndex: 2 }}>
          <Logo size={80} textColor="#fff" subtitleColor="rgba(255,255,255,.6)" />
        </div>

        <div
          style={{
            position: 'absolute',
            right: -40,
            top: 80,
            fontFamily: 'Fraunces, serif',
            fontSize: 340,
            fontWeight: 700,
            color: 'rgba(244,185,58,.09)',
            letterSpacing: '-0.04em',
            lineHeight: 0.85,
            pointerEvents: 'none',
          }}
        >
          2026
        </div>

        <div style={{ zIndex: 2, maxWidth: 440 }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '4px 10px',
              borderRadius: 999,
              background: 'rgba(244,185,58,.15)',
              color: 'var(--accent)',
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: '.04em',
              marginBottom: 18,
            }}
          >
            <span style={{ width: 6, height: 6, borderRadius: 3, background: 'var(--accent)' }} />
            FIFA WORLD CUP · USA · CAN · MEX
          </div>
          <h1
            className="serif"
            style={{ fontSize: 56, fontWeight: 700, lineHeight: 1.02, letterSpacing: '-0.02em', margin: 0 }}
          >
            Typuj mundial
            <br />
            z ekipą.
          </h1>
          <p style={{ fontSize: 16, lineHeight: 1.55, color: 'rgba(255,255,255,.68)', marginTop: 20 }}>
            Prywatne pokoje dla znajomych, publiczne ligi dla odważnych. Prosty scoring, jasne zasady,
            żadnego kombinowania.
          </p>
        </div>

        <div style={{ zIndex: 2, display: 'flex', gap: 28, color: 'rgba(255,255,255,.55)', fontSize: 12 }}>
          <Stat n="104" label="mecze" />
          <Stat n="48" label="drużyn" />
          <Stat n="3" label="kraje gospodarze" />
        </div>
      </div>

      <form
        onSubmit={onSubmit}
        className="auth-form"
        style={{
          padding: '72px 32px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <div style={{ width: '100%', maxWidth: 420, margin: '0 auto' }}>
          <div className="mobile-only" style={{ marginBottom: 24 }}>
            <Logo size={56} />
          </div>
          <div
            style={{
              fontSize: 12,
              color: '#5b6578',
              letterSpacing: '.08em',
              fontWeight: 600,
              textTransform: 'uppercase',
            }}
          >
            Reset hasła
          </div>
          <h2 className="serif" style={{ fontSize: 38, fontWeight: 700, margin: '6px 0 4px', letterSpacing: '-0.02em' }}>
            Zapomniałeś hasła?
          </h2>
          <div style={{ fontSize: 14, color: '#5b6578', marginBottom: 32 }}>
            Podaj adres e-mail przypisany do Twojego konta. Wyślemy na niego link do ustawienia nowego hasła.
          </div>

          {request.isSuccess ? (
            <div
              style={{
                padding: 14,
                background: 'rgba(31,157,85,.1)',
                color: '#0f6b34',
                borderRadius: 10,
                fontSize: 13,
                marginBottom: 18,
                lineHeight: 1.5,
              }}
            >
              Jeśli konto z tym adresem istnieje, wysłaliśmy link do resetu hasła. Sprawdź swoją skrzynkę.
            </div>
          ) : (
            <>
              <label style={fieldLabel}>E-MAIL</label>
              <Input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ty@example.com"
                style={{ marginBottom: 18 }}
              />

              <Btn type="submit" variant="primary" size="lg" fullWidth disabled={request.isPending}>
                {request.isPending ? 'Wysyłanie…' : 'Wyślij link resetu'}
              </Btn>
            </>
          )}

          <div style={{ marginTop: 18, textAlign: 'center', fontSize: 13 }}>
            <Link to="/login" style={{ color: '#5b6578', textDecoration: 'none' }}>
              Wróć do logowania
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
}

function Stat({ n, label }: { n: string; label: string }) {
  return (
    <div>
      <span className="serif" style={{ fontSize: 22, fontWeight: 700, color: '#fff', display: 'block' }}>
        {n}
      </span>
      {label}
    </div>
  );
}

const fieldLabel: React.CSSProperties = {
  display: 'block',
  fontSize: 12,
  color: '#5b6578',
  fontWeight: 600,
  letterSpacing: '.04em',
  marginBottom: 6,
};
